/**
 * feature-box.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Box,
  Typography,
} from '@mui/material';
import Spinner from 'components/spinner';


const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    margin: 0,
    padding: 0,
  },
  content: {
    transition: `${theme.transitions.duration.short}ms ${theme.transitions.easing.easeOut}`,
    height: '100%',
  },
  loadContainer: {
    transition: `${theme.transitions.duration.short}ms ${theme.transitions.easing.easeOut}`,
    justifyContent: 'center',
    pointerEvents: 'auto',
    backgroundColor: props => props.fadeBackground ? theme.palette.comp.fadedBackground : '',
    zIndex: 10,
  },
  loadIndicators: {
    flexDirection: props => props.loadingDirection || 'column',
    justifyContent: 'center',
    maxHeight: '60%',
    position: 'relative',
    top: props => props.spinnerTop ? `${props.spinnerTop}%` : '0%',
  },
  loadMessage: {
    color: theme.palette.sys.primary,
    fontWeight: theme.typography.fontWeightMedium,
    margin: theme.spacing(1),
  },
  spinner: {
    height: props => props.spinnerSize ? props.spinnerSize : 'auto',
    width: 'auto',
    minHeight: theme.spacing(3),
    maxHeight: '90%',
    '& path': {
      fill: props => props.spinnerColor || theme.palette.sys.primary
    }
  }
}));


export default React.forwardRef(function FeatureBox(props, ref) {
  const {
    loading,
    message,
    loadingDirection,
    spinnerSize,
    spinnerTop, 
    spinnerColor,
    className,
    fadeBackground,
    contentLoadingOpacity,
    sx,
    ...rest
  } = props;
  const classes = useStyles(props);

  const { style: newPropsStyle, ...newContentProps} = rest;
  const contentStyle = {
    ...newPropsStyle,
    opacity: loading
      ? contentLoadingOpacity !== undefined ? contentLoadingOpacity : 0.3
      : 1
  };

  return (
    <Box
      ref={ref}
      className={`${classes.container} ${className || ''}`}
      sx={sx}
      {...rest}
    >
      <div
        {...newContentProps}
        style={contentStyle}
        className={`${classes.content}`}
        data-testid="feature-box"
      >
        {rest.children}
      </div>
      {loading && 
      <div className={`flex-hc absolute-fill ${classes.loadContainer}`}>
        <div className={`flex-hc ${classes.loadIndicators}`}>
          <Spinner className={classes.spinner} />
          {message !== undefined &&
          <Typography variant='subtitle1' className={classes.loadMessage}>
            {message}
          </Typography>}
        </div>
      </div>}
    </Box>
  );
})